import { AxiosRequestConfig } from 'axios'
import {
  Report as Data,
  ReportCollection as Collection,
  ReportDataCommon,
  ReportDataBasicStatic,
} from '@/typings/api/Report'
import { Roadmap } from '@/typings/api/Roadmap'
import { RoadmapDirection } from '@/typings/api/RoadmapDirection'
import { RoadmapBaseEvent } from '@/typings/api/RoadmapBaseEvent'

import { BaseApiAuth } from '@/api/BaseApiAuth'


type ReportData =
  | ReportDataCommon
  | ReportDataBasicStatic

export class ReportsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'publications/reports';

  public getDownloadUrl(reportId: Data['id']) {
    const path = `${reportId}/download/`
    const [url] = this.getUrl(path)
    return url
  }

  public restart(id: Data['id'], config: AxiosRequestConfig = {}) {
    const path = `${id}/restart/`
    const [url] = this.getUrl(path)
    return this.request<never>('POST', url, config)
  }

  public getData(id: Data['id'], config: AxiosRequestConfig = {}) {
    const path = `${id}/data/`
    const [url] = this.getUrl(path)
    return this.request<ReportData>('GET', url, config)
  }

  public getDrilldownDirections(
    roadmapId: Roadmap['id'],
    roadmapDirectionId: RoadmapDirection['id'],
    isConfirmed?: boolean,
    config: AxiosRequestConfig = {},
  ) {
    const path = 'drilldown/directions/'

    const params = {
      roadmap_id: roadmapId,
      roadmap_direction_id: roadmapDirectionId,
      is_confirmed: isConfirmed,
    }

    const [url] = this.getUrl(path)
    return this.request<ReportData>('GET', url, { params, ...config })
  }

  public getDrilldownEvents(
    roadmapId: Roadmap['id'],
    baseEventId: RoadmapBaseEvent['id'],
    status: string,
    config: AxiosRequestConfig = {},
  ) {
    const path = 'drilldown/events/'

    const params = {
      roadmap_id: roadmapId,
      base_event_id: baseEventId,
      status,
    }

    const [url] = this.getUrl(path)
    return this.request<ReportData>('GET', url, { params, ...config })
  }
}
